(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('activeClubIdAccessor', activeClubIdAccessor);

    activeClubIdAccessor.$inject = ['localStorageService', 'user', 'adminMode', 'defaultAdminClubIdStorageKey'];
    function activeClubIdAccessor($localStorage, user, adminMode, storageKey) {
        var result = {};
        Object.defineProperty(result, 'clubId', { get: getClubId });
        return result;

        function getClubId() {
            return user.adminMode == adminMode.Club ? $localStorage.get(storageKey) : null;
        }
    }
})();